module.exports = __webpack_public_path__ + "img/DOC.f61c52f8.png";